jQuery(document).ready(function($) {

	//Show/Hide mobile menu (slide down)
	$(function() {
		var $burger		=	$('#hamburger-button');
		var $navigation =	$('#menu--primary');
		var $overlay 	=	$('#overlay');

		$burger.add($overlay).click(function()  {
			$navigation.toggleClass('menu--is-visible');
			$burger.toggleClass('hamburger--is-open');
			$overlay.toggleClass('overlay--is-visible');
		});
	});

	//Show/Hide search box on click
	$(function() {
		var $search			=	$('#search-button');
		var $searchMobile	=	$('#search-mobile');
		var $searchBox 		=	$('#search-box');
		var $searchForm 		=	$('#search-form');
		var $overlay 		=	$('#overlay');
		var $searchLoader 		=	$('#search-loader');

		$search.add($searchBox).add($searchMobile).click(function()  {
			$searchBox.toggleClass('search-box--is-visible');
			$searchForm.toggleClass('search-form--is-visible');
			$overlay.toggleClass('overlay--is-visible');
			$search.toggleClass('-is-active');
			$searchMobile.toggleClass('-is-active');
			setTimeout(focusSearchField, 300);
		});

		$('#search-product-submit').click(function()  {
			$searchForm.toggleClass('search-form--is-visible');
			$searchLoader.toggleClass('search-box__loader--is-visible');
		});
	});

	//Focus search input
	function focusSearchField(){
		$('#search-box').find('input[type="search"]').focus();
	}


	//Prevent search form from closing clicking on the input field
	$('#search-product-input').add('#search-product-submit').click(function(event){
		event.stopPropagation();
	});


	//Home slider
	$('#home-slider').slick({
		dots: false,
		arrows: false,
		infinite: true,
		speed: 3000,
		autoplaySpeed: 3000,
		fade: true,
		autoplay: true,
		cssEase: 'linear'
	});

	// New home slider
	$('.js-hero-slider').slick({
		dots: false,
		arrows: false,
		infinite: true,
		speed: 5000,
		autoplaySpeed: 5000,
		fade: true,
		autoplay: true,
		cssEase: 'linear'
	});

	//Product carousel
	$('#recently-viewed, .related.products .products, .c-product-carousel .products').slick({
		dots: false,
		arrows: false,
		infinite: false,
		speed: 300,
		slidesToShow: 1,
		slidesToScroll: 1,
		centerMode: true,
		variableWidth: true,
		focusOnSelect: false,
		autoplay: false,
		mobileFirst: true,
		responsive: [
	    {
	      breakpoint: 490,
	      settings: {
	        slidesToShow: 2,
			centerMode: false
	      }
	    },
	    {
	      breakpoint: 720,
	      settings: {
	        slidesToShow: 3,
			centerMode: false,
			arrows: true
	      }
	    },
	    {
	      breakpoint: 960,
	      settings: {
	        slidesToShow: 4,
			centerMode: false,
			arrows: true
	      }
	  	}]
	});

	//Comments carousel
	$('ol.commentlist').slick({
		dots: true,
		arrows: false,
		infinite: false,
		speed: 300,
		slidesToShow: 1,
		slidesToScroll: 1,
		centerMode: true,
		variableWidth: true,
		adaptiveHeight: true,
		focusOnSelect: false,
		autoplay: false,
		mobileFirst: true,
		responsive: [
		{
	      breakpoint: 768,
	      settings: {
	        slidesToShow: 1,
			arrows: true
	      }
	    },
	    {
	      breakpoint: 1024,
	      settings: 'unslick'
	    }]
	});

	//Quotes
	$('.quotes--slider').slick({
		dots: false,
		infinite: true,
		speed: 300,
		slidesToShow: 1,
		slidesToScroll: 1,
		centerMode: true,
		focusOnSelect: false
	});

	$('#carousel').slick({
		dots: false,
		arrows: true,
		infinite: true,
		speed: 300,
		slidesToShow: 1,
		centerMode: true,
		variableWidth: true,
		focusOnSelect: false,
		autoplay: true,
		autoplaySpeed: 3000
	});


	//Load warning message if browser does not support flexbox
	if (!Modernizr.flexbox) {
		$('body').prepend('<div class="browser-not-supported">Lo sentimos, el navegador que utilizas está desactualizado y es posible que la página no se visualice correctamente. Actualízalo o accede desde desde algún navegador alternativo para disfrutar de una experiencia completa</div>');
	}

	//Load object polyfill if browser doesn't support object-fit
	if (!Modernizr.objectfit){
	    jQuery.getScript("/wp-content/themes/bocaditosdulces/_assets/js/library/fitie.js");
	}


	//Remove :focus outline unless user is using the keyboard to navigate
	function handleFirstTab(e) {
		if (e.keyCode === 9) {
			document.body.classList.add('user-is-tabbing');
			window.removeEventListener('keydown', handleFirstTab);
			window.addEventListener('mousedown', handleMouseDownOnce);
		}
	}
	function handleMouseDownOnce() {
		document.body.classList.remove('user-is-tabbing');
		window.removeEventListener('mousedown', handleMouseDownOnce);
		window.addEventListener('keydown', handleFirstTab);
	}
	window.addEventListener('keydown', handleFirstTab);


	//Float labels on focus on WPCF7 contact forms
	$(".contact-form__input").focus(function() {
		$(this).parent().siblings('label').addClass('-has-value');
	})
	//Blur input fields on unfocus + if has no value
	.blur(function() {
		var text_val = $(this).val();
		if(text_val === "") {
			$(this).parent().siblings('label').removeClass('-has-value');
		}
	});


	//If JS enabled add classes to radio&checkbox inputs to style them
	$('input[type=checkbox]').after('<span class="[ custom-input__span  -checkmark ]"></span>').parent('label').addClass('[ custom-input ]');

	$('input[type=radio]').not($('.tabs__radio')).after('<span class="[ custom-input__span  -radio ]"></span>').parent('label').addClass('[ custom-input ]');


	//Smooth scroll on anchor links
	$('a[href*="#"]:not([href="#"], [href*="#tab"])').click(function() {
	  if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname) {
	    var target = $(this.hash);
	    target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
	    if (target.length) {
	      $('html, body').animate({
	        scrollTop: target.offset().top - 20
	      }, 500);
	      return false;
	    }
	  }
	});

	// Use select2 on homepage select fields
	$(document).ready(function() {
    $('.js-home-select').select2();
    $('.js-event-select').select2({
			placeholder: "Fechas señaladas...",
		});
		$('.js-cat-select').select2({
			placeholder: "Categorías...",
		});
	});


});
